import routes from '../components/user/routes';
import permissionsInfo from './permissionsInfo';
import {
  addTenantUser,
  addUser,
  deleteTenantUserById,
  deleteUserById
} from '../api/users';

export const addUserData = {
  // system configuration - users
  '/system-configuration/users/add': {
    header: 'System Configuration - Users',
    subheader: 'Create New User',
    returnRoute: routes.users(),
    permissions: permissionsInfo.users.create,
    add: addUser,
    isSystemConfiguration: true
  },
  // configuration - users
  '/configuration/users/add': {
    header: 'Configuration - Users',
    subheader: 'Create New User',
    returnRoute: routes.tenantUsers(),
    permissions: permissionsInfo.tenants_config.users.create,
    add: addTenantUser,
    isTenantConfiguration: true
  }
};

export const editUserData = {
  // system configuration - users
  '/system-configuration/users/:id': {
    fetchUrl: (id) => `/users/${id}`,
    header: 'System Configuration - Users',
    deleteUser: (id) => deleteUserById(id),
    returnRoute: routes.users(),
    popupLabels: (firstName, lastName) => (
      {body: `The user ${firstName} ${lastName} will be deleted.`}
    )
  },
  // configuration - users
  '/configuration/users/:id': {
    fetchUrl: (id) => `/tenants/users/${id}`,
    header: 'Configuration - Users',
    deleteUser: (id) => deleteTenantUserById(id),
    returnRoute: routes.tenantUsers(),
    popupLabels: (firstName, lastName) => (
      {body: `The user ${firstName} ${lastName} ` +
          `will be removed from current tenant.`}
    )
  }
};
